import { createNode } from '@glueapp/graph-types';

export const MergeText = createNode({
    id: 'Merge Text',
    name: 'Merge Text',
    description: 'A Block combining two texts',
    aiDescription: 'Concatenates two strings. Connect strings to "Text1" and "Text2" input ports; outputs the combined string on "Result".',
    category: 'Text',
    color: '#387cc8',
    integration: undefined,
    inPorts: {
        Text1: {
            kind: 'string',
        },
        Text2: {
            kind: 'string',
        },
    },
    outPorts: {
        Result: {
            kind: 'string',
        },
    },
    execute: function (input) {
        return { output: { Result: input.inPorts.Text1 + input.inPorts.Text2 } };
    },
});
